module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-indicator"
  }, [_c('div', {
    staticClass: "page-indicator-wrapper"
  }, [_c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openIndicator($event)
      }
    }
  }, [_vm._v("点击弹出 Indicator")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openIndicatorWithSpinner($event)
      }
    }
  }, [_vm._v("可配置 spinner")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "danger"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openIndicatorWithText($event)
      }
    }
  }, [_vm._v("点击弹出带有文字的 Indicator")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40e4ae8c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/indicator.vue
// module id = 545
// module chunks = 0